export class SheetModel {
  sheetName = 'å·¥ä½è¡¨1';
  title: string;
  desc: string;
  sheet = [];

  constructor(sheetName?: string, title?: string, desc?: string) {
    this.sheetName = this.handleSheetName(sheetName);
    this.title = title;
    this.desc = desc;
  }

  /**
   * è®¾ç½®è¡¨æ ¼åå®¹
   */
  setSheet(header: Array<any>, data: Array<any>) {
    data = data || [];
    data.forEach(item => {
      let result = [];
      header.forEach(headerItem => {
        let value = Object.create(null);
        value[headerItem.name] = item[headerItem.filedName];
        result.push(value);
      });
      this.sheet.push(result);
    });
  }

  /**
   * å¤çç¹æ®å­ç¬¦
   */

  handleSheetName(sheetName: string) {
    let newSheetName = sheetName.replace(/[\"\\\/\?\*\>\<\:\|]/g, '_');
    return newSheetName;
  }
}
